var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.QandAdata)?_c('div',{staticClass:"row qandatree"},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.QandAdata),function(q,index){return _c('XVqanda',_vm._b({key:index,attrs:{"collapsed":_vm.collapsed}},'XVqanda',q,false))}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }